import {
  Shield,
  Sword,
  Heart,
  Star,
  Sparkles,
  BookOpen,
  Zap,
  Crown,
  ArrowLeft,
  Gem,
  Info,
  Plus,
  Globe,
  Cloud,
  Sunrise,
  Users,
  User,
  Home,
  BarChart2,
  UserPlus,
  MessageCircle,
  Calendar,
  Trophy,
  Settings,
  Flame,
  Droplet,
  Leaf,
  Sun,
  Moon,
  Percent,
  Target,
  Repeat,
  Shield as ShieldIcon,
  Swords,
  Gauge,
  Battery
} from 'lucide-react';

import { COMMON_ASSETS } from './commonManifest.js';
import { ASSETS } from './assetManifest.js';
import { RESOURCES } from './data.js';

const ImageIcon = ({
  src,
  size = 38,
  strokeWidth = 2,
  color = "currentColor",
  absoluteStrokeWidth,
  className = "",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={absoluteStrokeWidth ? strokeWidth : strokeWidth * 24/size}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-image ${className}`}
    {...props}
  >
    <image
      href={src}
      x="0"
      y="0"
      width="24"
      height="24"
      preserveAspectRatio="xMidYMid meet"
    />
  </svg>
);

const createNavIcon = (path) => () => {
  if (!path) {
    throw new Error("received non-existent path when trying to create nav icon");
  }
  return <ImageIcon src={path} />
};

const baseIconMap = {
  // Scene/nav buttons
  messages: createNavIcon(COMMON_ASSETS.nav.chat?.path),
  daily: createNavIcon(COMMON_ASSETS.nav.daily?.path),
  territory: createNavIcon(COMMON_ASSETS.nav.minigame?.path),
  friends: createNavIcon(COMMON_ASSETS.nav.friends?.path),
  ranking: createNavIcon(COMMON_ASSETS.nav.ranking?.path),
  missions: createNavIcon(COMMON_ASSETS.nav.missions?.path),
  settings: createNavIcon(COMMON_ASSETS.nav.settings?.path),
  home: createNavIcon(COMMON_ASSETS.nav.home?.path),
  team: createNavIcon(COMMON_ASSETS.nav.team?.path),
  characters: createNavIcon(COMMON_ASSETS.nav.characters?.path),
  loadout: createNavIcon(COMMON_ASSETS.nav.loadout?.path),
  character: createNavIcon(COMMON_ASSETS.nav.character?.path),
  progress: createNavIcon(COMMON_ASSETS.nav.progress?.path),
  banners: createNavIcon(COMMON_ASSETS.nav.banners?.path),

  // resources
  energy: createNavIcon(ASSETS.resources.energy?.path),
  gadgetParts: createNavIcon(ASSETS.resources.gadgetParts?.path),
  heroTokens: createNavIcon(ASSETS.resources.heroTokens?.path),

  // character stats
  hp: Heart,
  attack: Sword,
  defense: Shield,
  elementalMastery: Sparkles,
  stamina: Zap,

  // elements
  cosmic: Globe,
  void: Cloud,
  astral: Sunrise,
};

const iconMap = new Proxy(baseIconMap, {
  get(target, prop) {
    if (prop in target) {
      return target[prop];
    }
    console.warn(`Invalid icon type requested: ${String(prop)}. Falling back to Info icon.`);
    return Info;
  }
});

function isValidIconType(type) {
  return type in baseIconMap;
}

function getIcon(type) {
  return iconMap[type];
}

export default iconMap;
